import { useLocation } from 'react-router';

export enum FeatureFlags {
  EnableSubscription = 'enableSubscription',
  SandboxSubscription = 'sandboxSubscription',
  EnableUndoRedo = 'enableUndoRedo',
  DebugLogging = 'debugLogging',
}

export const isFeatureFlagEnabled = (flag: FeatureFlags): boolean => {
  const flags = new URLSearchParams(window.location.search).get('featureFlags');
  return flags?.split(',').includes(flag) ?? false;
};

export const useFeatureFlags = (flag: FeatureFlags): boolean => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const flags = searchParams.get('featureFlags');

  if (flags) {
    return flags.split(',').includes(flag);
  }

  return false;
};
